import { jsPDF } from "jspdf";
import { applyPlugin } from "jspdf-autotable";
import html2canvas from "html2canvas";

// Apply autotable plugin to jsPDF
applyPlugin(jsPDF);

const COLORS = {
  primary: [6, 78, 59],
  green: [16, 185, 129],
  orange: [245, 158, 11],
  red: [239, 68, 68],
  blue: [59, 130, 246],
  gray: [113, 113, 122],
  lightGray: [244, 244, 245],
  white: [255, 255, 255],
  black: [24, 24, 27],
};

const AICLO_LOGO_BASE64 = "data:image/png;base64,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";

const fmt = (v) => {
  const abs = Math.abs(v || 0);
  const sign = v < 0 ? "-" : "";
  if (abs >= 1000000) return `${sign}${(abs / 1000000).toFixed(1)}M`;
  if (abs >= 1000) return `${sign}${(abs / 1000).toFixed(1)}K`;
  return `${sign}${abs.toFixed(0)}`;
};

const fmtC = (v) => `€${fmt(v)}`;
const fmtN = (v) => (v || 0).toLocaleString("it-IT");

function addHeader(doc, logoImg, pageTitle) {
  // Logo
  if (logoImg) {
    doc.addImage(logoImg, "PNG", 20, 12, 18, 18);
  }
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.black);
  doc.text("Aiclo Financial Planner", logoImg ? 42 : 20, 24);

  // Page title
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...COLORS.gray);
  doc.text(pageTitle, doc.internal.pageSize.width - 20, 24, { align: "right" });

  // Divider
  doc.setDrawColor(...COLORS.lightGray);
  doc.setLineWidth(0.5);
  doc.line(20, 34, doc.internal.pageSize.width - 20, 34);
}

function addCoverPage(doc, logoImg, modelName) {
  const w = doc.internal.pageSize.width;
  const h = doc.internal.pageSize.height;

  // Background accent
  doc.setFillColor(...COLORS.primary);
  doc.rect(0, 0, w, 100, "F");

  // Logo
  if (logoImg) {
    doc.addImage(logoImg, "PNG", w / 2 - 15, 25, 30, 30);
  }

  // Title
  doc.setFontSize(28);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.white);
  doc.text("Financial Planner", w / 2, 72, { align: "center" });

  // Model name
  doc.setFontSize(18);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...COLORS.black);
  doc.text(modelName || "Modello Finanziario", w / 2, 125, { align: "center" });

  // Date
  doc.setFontSize(11);
  doc.setTextColor(...COLORS.gray);
  const date = new Date().toLocaleDateString("it-IT", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  doc.text(`Generato il ${date}`, w / 2, 140, { align: "center" });

  // Table of contents
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.black);
  doc.text("Contenuto", w / 2, 175, { align: "center" });

  const items = ["Anno 1 - Input & Proiezioni", "Anno 2 - Input & Proiezioni", "Anno 3 - Input & Proiezioni", "Vista Consolidata (3 Anni)"];
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  items.forEach((item, i) => {
    doc.setTextColor(...COLORS.gray);
    doc.text(`${i + 1}.`, w / 2 - 50, 195 + i * 14);
    doc.setTextColor(...COLORS.black);
    doc.text(item, w / 2 - 40, 195 + i * 14);
  });

  // Footer
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.text("Powered by Aiclo", w / 2, h - 15, { align: "center" });
}

function addKPISection(doc, yearData, y, label) {
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.primary);
  doc.text(`KPI - ${label}`, 20, y);
  y += 8;

  const kpis = [
    ["MRR Inizio", fmtC(yearData.basic?.mrr_input)],
    ["MRR Fine Anno", fmtC(yearData.basic?.mrr_end)],
    ["Clienti Inizio", `${yearData.basic?.customers_start || 0}`],
    ["Clienti Fine Anno", `${yearData.basic?.customers_end || 0}`],
    ["Margine Lordo", `${yearData.basic?.gross_margin || 0}%`],
    ["CAC", fmtC(yearData.cac?.fully_loaded_cac)],
    ["LTV", fmtC(yearData.unit_economics?.ltv)],
    ["LTV/CAC", `${(yearData.unit_economics?.ltv_cac_ratio || 0).toFixed(1)}x`],
    ["Runway", `${yearData.cash?.runway_months || 0} mesi`],
    ["Burn Rate", `${fmtC(yearData.cash?.monthly_burn_rate || 0)}/mese`],
  ];

  doc.autoTable({
    startY: y,
    head: [["Metrica", "Valore"]],
    body: kpis,
    theme: "grid",
    headStyles: { fillColor: COLORS.primary, textColor: COLORS.white, fontStyle: "bold", fontSize: 9 },
    bodyStyles: { fontSize: 9 },
    alternateRowStyles: { fillColor: [249, 250, 251] },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 60 }, 1: { halign: "right" } },
    margin: { left: 20, right: 20 },
  });

  return doc.lastAutoTable.finalY + 8;
}

function addPLSection(doc, projections, y, label) {
  const totalRev = projections.reduce((s, p) => s + p.revenue, 0);
  const totalVar = projections.reduce((s, p) => s + p.variable_costs, 0);
  const totalFix = projections.reduce((s, p) => s + p.fixed_costs, 0);
  const totalProfit = projections.reduce((s, p) => s + p.profit, 0);

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.primary);
  doc.text(`Conto Economico - ${label}`, 20, y);
  y += 8;

  const pctOf = (v) => (totalRev > 0 ? `${Math.round((v / totalRev) * 100)}%` : "0%");

  doc.autoTable({
    startY: y,
    head: [["Voce", "Totale", "% Entrate"]],
    body: [
      ["Entrate", fmtC(totalRev), "100%"],
      ["Costi Variabili", fmtC(totalVar), pctOf(totalVar)],
      ["Costi Fissi", fmtC(totalFix), pctOf(totalFix)],
      ["Profitto Netto", fmtC(totalProfit), pctOf(totalProfit)],
    ],
    theme: "grid",
    headStyles: { fillColor: COLORS.primary, textColor: COLORS.white, fontStyle: "bold", fontSize: 9 },
    bodyStyles: { fontSize: 9 },
    columnStyles: {
      0: { fontStyle: "bold", cellWidth: 55 },
      1: { halign: "right", cellWidth: 45 },
      2: { halign: "right", cellWidth: 35 },
    },
    didParseCell: (data) => {
      if (data.section === "body" && data.row.index === 3) {
        data.cell.styles.textColor = totalProfit >= 0 ? COLORS.green : COLORS.red;
        data.cell.styles.fontStyle = "bold";
      }
    },
    margin: { left: 20, right: 20 },
  });

  return doc.lastAutoTable.finalY + 8;
}

function addProjectionsTable(doc, projections, y, label) {
  if (y > 220) {
    doc.addPage();
    y = 45;
  }

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.primary);
  doc.text(`Proiezioni Mensili - ${label}`, 20, y);
  y += 8;

  const body = projections.map((p) => [
    `M${p.month}`,
    fmtC(p.mrr),
    `${p.customers}`,
    fmtC(p.revenue),
    fmtC(p.variable_costs),
    fmtC(p.fixed_costs),
    fmtC(p.profit),
    fmtC(p.cash_remaining),
  ]);

  doc.autoTable({
    startY: y,
    head: [["Mese", "MRR", "Clienti", "Entrate", "C. Var.", "C. Fissi", "Profitto", "Cash"]],
    body: body,
    theme: "grid",
    headStyles: { fillColor: COLORS.primary, textColor: COLORS.white, fontStyle: "bold", fontSize: 7, cellPadding: 2 },
    bodyStyles: { fontSize: 7, cellPadding: 2 },
    alternateRowStyles: { fillColor: [249, 250, 251] },
    columnStyles: {
      0: { cellWidth: 14, halign: "center" },
      1: { halign: "right" },
      2: { halign: "center", cellWidth: 16 },
      3: { halign: "right" },
      4: { halign: "right" },
      5: { halign: "right" },
      6: { halign: "right" },
      7: { halign: "right" },
    },
    didParseCell: (data) => {
      if (data.section === "body" && data.column.index === 6) {
        const val = projections[data.row.index]?.profit || 0;
        data.cell.styles.textColor = val >= 0 ? COLORS.green : COLORS.red;
      }
    },
    margin: { left: 14, right: 14 },
  });

  return doc.lastAutoTable.finalY + 8;
}

function addPipelineSection(doc, yearData, y) {
  const p = yearData.pipeline;
  const g = yearData.growth;
  if (!p) return y;

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.primary);
  doc.text("Pipeline & Vendite", 20, y);
  y += 8;

  doc.autoTable({
    startY: y,
    head: [["Metrica", "Valore"]],
    body: [
      ["Lead Richiesti", fmtN(p.leads_required)],
      ["Discovery Richieste", fmtN(p.discoveries_required)],
      ["Demo Richieste", fmtN(p.demos_required)],
      ["Nuovi Clienti", fmtN(g?.new_customers_to_acquire || 0)],
      ["Sales Rep Necessari", `${yearData.sales_capacity?.sales_reps_needed || 0}`],
      ["CAC", fmtC(yearData.cac?.fully_loaded_cac)],
      ["Budget Marketing Annuale", fmtC(yearData.marketing?.annual_marketing_budget)],
    ],
    theme: "grid",
    headStyles: { fillColor: COLORS.primary, textColor: COLORS.white, fontStyle: "bold", fontSize: 9 },
    bodyStyles: { fontSize: 9 },
    alternateRowStyles: { fillColor: [249, 250, 251] },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 65 }, 1: { halign: "right" } },
    margin: { left: 20, right: 20 },
  });

  return doc.lastAutoTable.finalY + 8;
}

function drawBarChart(doc, projections, y, pageWidth) {
  const chartX = 25;
  const chartW = pageWidth - 50;
  const chartH = 65;
  const months = projections.length;
  if (months === 0) return y;

  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.primary);
  doc.text("Conto Economico - Grafico", 20, y);
  y += 6;

  const maxVal = Math.max(...projections.map((p) => Math.max(p.revenue, p.fixed_costs + p.variable_costs)));
  const barGroupW = chartW / months;
  const barW = barGroupW * 0.22;
  const scale = maxVal > 0 ? chartH / maxVal : 1;

  // Background
  doc.setFillColor(250, 250, 250);
  doc.rect(chartX, y, chartW, chartH, "F");

  // Grid lines
  doc.setDrawColor(230, 230, 230);
  doc.setLineWidth(0.2);
  for (let i = 0; i <= 4; i++) {
    const gy = y + (chartH / 4) * i;
    doc.line(chartX, gy, chartX + chartW, gy);
  }

  projections.forEach((p, i) => {
    const x = chartX + i * barGroupW + barGroupW * 0.1;

    // Revenue bar (green)
    const revH = p.revenue * scale;
    doc.setFillColor(...COLORS.green);
    doc.rect(x, y + chartH - revH, barW, revH, "F");

    // Variable costs bar (orange)
    const varH = p.variable_costs * scale;
    doc.setFillColor(...COLORS.orange);
    doc.rect(x + barW + 1, y + chartH - varH, barW, varH, "F");

    // Fixed costs bar (red)
    const fixH = p.fixed_costs * scale;
    doc.setFillColor(...COLORS.red);
    doc.rect(x + (barW + 1) * 2, y + chartH - fixH, barW, fixH, "F");

    // Month label
    doc.setFontSize(5);
    doc.setTextColor(...COLORS.gray);
    doc.text(`${p.month}`, x + barGroupW * 0.35, y + chartH + 4, { align: "center" });
  });

  // Profit line
  doc.setDrawColor(...COLORS.primary);
  doc.setLineWidth(0.8);
  const minProfit = Math.min(...projections.map((p) => p.profit));
  const maxProfit = Math.max(...projections.map((p) => p.profit));
  const profitRange = maxProfit - minProfit || 1;

  for (let i = 1; i < projections.length; i++) {
    const x1 = chartX + (i - 1) * barGroupW + barGroupW * 0.5;
    const x2 = chartX + i * barGroupW + barGroupW * 0.5;
    const y1 = y + chartH - ((projections[i - 1].profit - minProfit) / profitRange) * chartH;
    const y2 = y + chartH - ((projections[i].profit - minProfit) / profitRange) * chartH;
    doc.line(x1, y1, x2, y2);
  }

  // Legend
  y += chartH + 10;
  const legends = [
    { label: "Entrate", color: COLORS.green },
    { label: "C. Variabili", color: COLORS.orange },
    { label: "C. Fissi", color: COLORS.red },
    { label: "Profitto", color: COLORS.primary },
  ];
  let lx = chartX;
  legends.forEach((l) => {
    doc.setFillColor(...l.color);
    doc.rect(lx, y - 2, 4, 4, "F");
    doc.setFontSize(7);
    doc.setTextColor(...COLORS.black);
    doc.text(l.label, lx + 6, y + 1);
    lx += 35;
  });

  return y + 10;
}

function addCostsBreakdown(doc, model, yearKey, yearData, y) {
  const st = model.sales_team[yearKey] || {};
  const mb = model.marketing_budget[yearKey] || {};
  const sm = model.sales_marketing_cost[yearKey] || {};
  const op = model.operating_costs[yearKey] || {};

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.primary);
  doc.text("Dettaglio Costi Input", 20, y);
  y += 8;

  const rows = [
    ["MARKETING", "", ""],
    ["  CPL", `€${mb.cost_per_lead || 0}`, "/lead"],
    ["  Eventi", `€${fmtN(mb.event_costs || 0)}`, "/mese"],
    ["  Agenzia", `€${fmtN(mb.agency_costs || 0)}`, "/mese"],
    ["  Team Marketing", `€${fmtN(mb.team_salaries || 0)}`, "/mese"],
    ["SALES", "", ""],
    ["  Stipendi Sales", `€${fmtN(sm.sales_salaries || 0)}`, "/mese"],
    ["  Head of Sales", `€${fmtN(sm.head_of_sales_salary || 0)}`, "/mese"],
    ["  Recruiting", `€${fmtN(sm.recruiting_costs || 0)}`, "/mese"],
    ["  CRM & Tools", `€${fmtN(sm.crm_tools || 0)}`, "/mese"],
    ["  Commissione/Utente", `€${st.commission_per_user || 0}`, "/utente"],
    ["  Costo Fisso/Rep", `€${fmtN(st.fixed_cost_per_rep || 0)}`, "/mese"],
    ["OPERATIVI", "", ""],
    ["  Engineering", `€${fmtN(op.engineering_team || 0)}`, "/mese"],
    ["  AI & Cloud", `€${fmtN(op.ai_infrastructure || 0)}`, "/mese"],
    ["  Customer Success", `€${fmtN(op.customer_success || 0)}`, "/mese"],
    ["  Admin & Legale", `€${fmtN(op.admin_legal || 0)}`, "/mese"],
    ["  Ufficio & Tools", `€${fmtN(op.office_tools || 0)}`, "/mese"],
  ];

  doc.autoTable({
    startY: y,
    head: [["Voce", "Importo", ""]],
    body: rows,
    theme: "grid",
    headStyles: { fillColor: COLORS.primary, textColor: COLORS.white, fontStyle: "bold", fontSize: 8 },
    bodyStyles: { fontSize: 8 },
    alternateRowStyles: { fillColor: [249, 250, 251] },
    didParseCell: (data) => {
      if (data.section === "body") {
        const text = rows[data.row.index]?.[0] || "";
        if (text === text.toUpperCase() && text.trim() && !text.startsWith(" ")) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [229, 231, 235];
        }
      }
    },
    columnStyles: { 0: { cellWidth: 55 }, 1: { halign: "right", cellWidth: 35 }, 2: { cellWidth: 20 } },
    margin: { left: 20, right: 20 },
  });

  return doc.lastAutoTable.finalY + 8;
}

function addUseOfFunds(doc, model, metrics, y, pageWidth) {
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...COLORS.primary);
  doc.text("Use of Funds - Distribuzione Costi Fissi", 20, y);
  y += 8;

  const calcYear = (yearKey) => {
    const sm = model.sales_marketing_cost[yearKey] || {};
    const mb = model.marketing_budget[yearKey] || {};
    const op = model.operating_costs[yearKey] || {};
    const ymData = metrics[yearKey];
    const salesTeamCost = (ymData?.sales_capacity?.total_sales_team_cost || 0);

    const goToMarket =
      (ymData?.marketing?.annual_marketing_budget || 0) +
      (sm.sales_salaries + sm.head_of_sales_salary + sm.recruiting_costs + sm.crm_tools + sm.marketing_team_salaries) * 12 +
      salesTeamCost +
      (op.customer_success || 0) * 12;
    const infrastructure = (op.ai_infrastructure || 0) * 12;
    const product = (op.engineering_team || 0) * 12;
    const operations = ((op.admin_legal || 0) + (op.office_tools || 0)) * 12;

    return { goToMarket, infrastructure, product, operations };
  };

  let total = { goToMarket: 0, infrastructure: 0, product: 0, operations: 0 };
  ["year1", "year2", "year3"].forEach((yk) => {
    const c = calcYear(yk);
    total.goToMarket += c.goToMarket;
    total.infrastructure += c.infrastructure;
    total.product += c.product;
    total.operations += c.operations;
  });

  const grandTotal = total.goToMarket + total.infrastructure + total.product + total.operations;
  const pct = (v) => (grandTotal > 0 ? `${Math.round((v / grandTotal) * 100)}%` : "0%");

  const categories = [
    ["Go To Market", fmtC(total.goToMarket), pct(total.goToMarket)],
    ["Infrastructure", fmtC(total.infrastructure), pct(total.infrastructure)],
    ["Product", fmtC(total.product), pct(total.product)],
    ["Operations", fmtC(total.operations), pct(total.operations)],
    ["TOTALE", fmtC(grandTotal), "100%"],
  ];

  doc.autoTable({
    startY: y,
    head: [["Categoria", "Importo (3 Anni)", "% Totale"]],
    body: categories,
    theme: "grid",
    headStyles: { fillColor: COLORS.primary, textColor: COLORS.white, fontStyle: "bold", fontSize: 9 },
    bodyStyles: { fontSize: 9 },
    alternateRowStyles: { fillColor: [249, 250, 251] },
    didParseCell: (data) => {
      if (data.section === "body" && data.row.index === 4) {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fillColor = [229, 231, 235];
      }
    },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 50 }, 1: { halign: "right", cellWidth: 45 }, 2: { halign: "right", cellWidth: 30 } },
    margin: { left: 20, right: 20 },
  });

  // Draw simple horizontal bar chart
  y = doc.lastAutoTable.finalY + 8;
  const barColors = [COLORS.green, COLORS.orange, COLORS.blue, COLORS.red];
  const names = ["Go To Market", "Infrastructure", "Product", "Operations"];
  const values = [total.goToMarket, total.infrastructure, total.product, total.operations];
  const maxBarW = pageWidth - 90;

  values.forEach((v, i) => {
    const w = grandTotal > 0 ? (v / grandTotal) * maxBarW : 0;
    doc.setFillColor(...barColors[i]);
    doc.roundedRect(55, y, w, 6, 1, 1, "F");
    doc.setFontSize(7);
    doc.setTextColor(...COLORS.black);
    doc.text(names[i], 20, y + 4.5);
    doc.setTextColor(...COLORS.gray);
    doc.text(pct(v), 55 + w + 3, y + 4.5);
    y += 11;
  });

  return y + 5;
}

function addFooter(doc, pageNum) {
  const w = doc.internal.pageSize.width;
  const h = doc.internal.pageSize.height;
  doc.setFontSize(7);
  doc.setTextColor(...COLORS.gray);
  doc.text("Aiclo Financial Planner", 20, h - 10);
  doc.text(`Pagina ${pageNum}`, w - 20, h - 10, { align: "right" });
}

export async function generatePDF(model, metrics, globalBep) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.width;

  // Use embedded base64 logo to avoid CORS issues
  const logoImg = AICLO_LOGO_BASE64;

  // Cover page
  addCoverPage(doc, logoImg, model.name);
  let pageNum = 1;

  // For each year
  const years = [
    { key: "year1", label: "Anno 1" },
    { key: "year2", label: "Anno 2" },
    { key: "year3", label: "Anno 3" },
  ];

  for (const { key, label } of years) {
    const yearData = metrics[key];
    if (!yearData) continue;

    // Page 1: KPIs + P&L + Pipeline
    doc.addPage();
    pageNum++;
    addHeader(doc, logoImg, label);
    addFooter(doc, pageNum);

    let y = 42;
    y = addKPISection(doc, yearData, y, label);
    y = addPLSection(doc, yearData.monthly_projections, y, label);

    if (y > 200) {
      doc.addPage();
      pageNum++;
      addHeader(doc, logoImg, `${label} - Pipeline`);
      addFooter(doc, pageNum);
      y = 42;
    }
    y = addPipelineSection(doc, yearData, y);

    // Page 2: Costs + Chart
    doc.addPage();
    pageNum++;
    addHeader(doc, logoImg, `${label} - Costi & Grafico`);
    addFooter(doc, pageNum);
    y = 42;
    y = addCostsBreakdown(doc, model, key, yearData, y);

    if (y > 170) {
      doc.addPage();
      pageNum++;
      addHeader(doc, logoImg, `${label} - Grafico`);
      addFooter(doc, pageNum);
      y = 42;
    }
    y = drawBarChart(doc, yearData.monthly_projections, y, pageWidth);

    // Page 3: Monthly projections table
    doc.addPage();
    pageNum++;
    addHeader(doc, logoImg, `${label} - Proiezioni`);
    addFooter(doc, pageNum);
    y = 42;
    y = addProjectionsTable(doc, yearData.monthly_projections, y, label);
  }

  // Consolidated
  const consolidated = metrics.consolidated;
  if (consolidated) {
    doc.addPage();
    pageNum++;
    addHeader(doc, logoImg, "Consolidato 3 Anni");
    addFooter(doc, pageNum);
    let y = 42;

    // P&L consolidated
    y = addPLSection(doc, consolidated.monthly_projections, y, "3 Anni");

    // BEP
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...COLORS.primary);
    doc.text("Break-Even Point", 20, y);
    y += 6;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...COLORS.black);
    if (globalBep?.reached) {
      doc.text(`BEP raggiunto al Mese ${globalBep.month}`, 20, y);
    } else {
      doc.text("BEP non raggiunto nei 36 mesi", 20, y);
    }
    y += 10;

    // Use of Funds
    y = addUseOfFunds(doc, model, metrics, y, pageWidth);

    // Chart consolidated
    if (y > 170) {
      doc.addPage();
      pageNum++;
      addHeader(doc, logoImg, "Consolidato - Grafico");
      addFooter(doc, pageNum);
      y = 42;
    }
    y = drawBarChart(doc, consolidated.monthly_projections, y, pageWidth);

    // Consolidated projections table
    doc.addPage();
    pageNum++;
    addHeader(doc, logoImg, "Consolidato - Proiezioni");
    addFooter(doc, pageNum);
    y = 42;
    y = addProjectionsTable(doc, consolidated.monthly_projections, y, "3 Anni");
  }

  doc.save(`${model.name || "financial-model"}_report.pdf`);
}
